import React from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import useAutoLogout from "../hooks/useAutoLogout";
import LogoutConfirmModal from "../components/LogoutConfirmModal";

// Public routes that should never trigger auto-logout
const PUBLIC_ROUTES = ["/login", "/", "/unauthorized"];

const Layout = ({ children }) => {
  const location = useLocation();
  const isPublic  = PUBLIC_ROUTES.includes(location.pathname);
  const showNavbar = ["/dashboard", "/admin-dashboard", "/superuser-dashboard", "/Manager-dashboard"].includes(location.pathname);

  // Auto-logout — only active on protected (non-public) routes
  const { showWarning, countdown, stayLoggedIn, performLogout } = useAutoLogout({
    enabled: !isPublic,
  });

  if (isPublic) {
    return <>{children}</>;
  }

  return (
    <div className="body-bg min-h-screen font-inter flex flex-col">
      {showNavbar && <Navbar />}

      <main className="p-6 max-w-7xl mx-auto flex-1">
        {children}
      </main>

      <footer className="text-center text-sm text-app-muted py-6 bg-transparent border-t-0 shadow-none">
        © {new Date().getFullYear()} Tasket — Greenated — made with love⚡
      </footer>

      {/* Auto-logout idle warning */}
      {showWarning && (
        <LogoutConfirmModal
          mode="idle"
          countdown={countdown}
          onCancel={stayLoggedIn}
          onConfirm={performLogout}
        />
      )}
    </div>
  );
};

export default Layout;
